module.exports = __webpack_public_path__ + "img/quito-black.98365ddf.jpg";